export function loadGoogleFont(fontUrl: string) {
  const style = document.createElement('style')
  style.textContent = `
        @import url('${fontUrl}');
    `
  document.head.appendChild(style)
}
